var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"flex-shrink-0"},[_c('ul',{staticClass:"d-flex nav"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.name,class:[
        'nav-item',
        _vm.additionalItemClass,
        {
          active: tab.name == _vm.currentTab,
        } ],on:{"click":function($event){return _vm.selectTab(tab)}}},[_c('span',{staticClass:"nav-link"},[_vm._v(_vm._s(tab.label))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }